import { request } from'./Omni';
import Config from '../comun/Config';
import Constantes from '../comun/Constantes';

const AdminServiciosAPI = {
  getRegistro: async (parametro) => {
    const _url = `${Config.apiPhp}${parametro}`;
    //console.log(_url);
    return request(_url, {
      method: "GET",
      headers: {"Content-Type": "application/json"},
    });
  },
  postRegistro: async (tabla,parametros) => {
    const _url = `${Config.apiPhp}${tabla}`;
    //console.log(_url);
    if(localStorage.getItem(Constantes.ADMINUSUARIO)!==null){
      parametros['nombreusuario'] = localStorage.getItem(Constantes.ADMINUSUARIO)
    }
    return request(_url, {
      method: "POST",
      headers: {"Content-Type": "application/x-www-form-urlencoded"},
      body: new URLSearchParams(parametros),
    });
  },
  postAdminRegistro: async (tabla,parametros,token) => {
    const _url = `${Config.apiAdminPhp}${tabla}`;
    return request(_url, {
      method: "POST",
      headers: {"Content-Type": "application/x-www-form-urlencoded","authorization": token},
      body: new URLSearchParams(parametros),
    });
  },
}

export default AdminServiciosAPI;